import { render, staticRenderFns } from "./HostelFloors.vue?vue&type=template&id=ee15bc90"
import script from "./HostelFloors.vue?vue&type=script&lang=js"
export * from "./HostelFloors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports